import { TreatmentDesignRevisionJudgement, TreatmentDesignRevisionJudgementEditModel } from '../../../core/model';
import { TreatmentTypeOriginalId } from '../../../core/model/treatmentType';

/**
 * Configuration for the QC Accept Confirmation Dialog.
 * Used when design revision judgement needs to be collected.
 */
export interface QCAcceptConfirmDialogConfig {
    readonly treatmentId?: string | null;
    readonly treatmentTypeId?: TreatmentTypeOriginalId | null;
    readonly designRevisionJudgement?: TreatmentDesignRevisionJudgement | null;
}

/**
 * Result returned when the QC Accept Confirmation Dialog closes.
 */
export interface QCAcceptConfirmDialogResult {
    readonly confirmed: boolean;
    readonly revisionJudgement?: TreatmentDesignRevisionJudgementEditModel | null;
}
